import { Component, EventEmitter, Output, input } from '@angular/core';
import { ContentBuilderFieldColors } from '@shared/interfaces/content-builder.interface';
import { FidelityType } from '../fidelity-type.enum';

@Component({
  selector: 'app-kiosk-register-confirmation-step',
  template: `
    <div class="flex flex-col items-center justify-center gap-12">
      <h1
        class="w-full text-center text-4xl font-bold"
        [style.color]="accentColor()?.font | contentBuilderColor"
      >
        {{
          fidelityType() + '.create-or-link-account.kiosk-register-confirmation-step.title'
            | translate
        }}
      </h1>
      <i
        class="icon icon-n-check text-9xl"
        [style.color]="accentColor()?.font | contentBuilderColor"
      ></i>
      <div class="w-full">
        <app-button-atom
          size="L"
          [label]="
            fidelityType() + '.create-or-link-account.kiosk-register-confirmation-step.continue'
              | translate
          "
          type="kiosk-primary"
          [overrideTextColor]="accentColor()?.font"
          [overrideBgColor]="accentColor()?.background"
          (click)="onCompleteStep()"
          [full]="true"
        ></app-button-atom>
      </div>
    </div>
  `,
  standalone: false,
})
export class KioskRegisterConfirmationStepComponent {
  @Output() onComplete = new EventEmitter<void>();

  readonly accentColor = input<ContentBuilderFieldColors>();
  readonly fidelityType = input.required<FidelityType>();

  onCompleteStep(): void {
    this.onComplete.next();
  }
}
